import Assigned from './styled';

export default Assigned;
